import PropTypes from 'prop-types'
import { Box, FormControl, FormLabel, Grid, GridItem, Heading, Select } from '@chakra-ui/react'
import { QUOTE_PAYMENT_TERMS_OPTIONS } from 'lib'

export const AdhocPaymentTermsForm = ({ form, setForm, ...rest }) => {
  return (
    <Box {...rest}>
      <Grid
        templateColumns="5fr 1fr"
        rowGap={5}
        columnGap={10}
        w="900px"
        maxW="100%"
      >
        <GridItem>
          <Heading size="md">Payment Terms</Heading>
        </GridItem>
        <GridItem></GridItem>
        <GridItem>
          <FormControl isRequired>
            <FormLabel>Options</FormLabel>
            <Select
              value={form.paymentTerms}
              onChange={e => setForm(draft => { draft.paymentTerms = e.target.value })}
              placeholder="Select"
            >
              <option value={QUOTE_PAYMENT_TERMS_OPTIONS.Standard}>{QUOTE_PAYMENT_TERMS_OPTIONS.Standard}</option>
              <option value={QUOTE_PAYMENT_TERMS_OPTIONS.POOnly}>{QUOTE_PAYMENT_TERMS_OPTIONS.POOnly}</option>
              <option value={QUOTE_PAYMENT_TERMS_OPTIONS.ClientInstall}>{QUOTE_PAYMENT_TERMS_OPTIONS.ClientInstall}</option>
            </Select>
          </FormControl>
        </GridItem>
      </Grid>
    </Box>
  )
}

AdhocPaymentTermsForm.propTypes = {
  form: PropTypes.object,
  setForm: PropTypes.func
}
